// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcc_a bhm_ke","ListItemIcon--empty":"bcc_b bhm_fl"};